<template>
    <div class="flex items-center gap-2">
        <p class="-mt-1 flex items-center justify-center rounded-full border border-black w-4 h-4 text-xxs">
            {{ stepNumber }}
        </p>

        <p class="flex mb-1 text-base font-freizeit">
            {{ groupName }}
        </p>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            groupName: {
                type: String,
                required: true,
            },

            groupIndex: {
                type: Number,
                required: true,
            },
        },

        computed: {
            stepNumber() {
                return this.groupIndex + 1;
            },
        },
    };
</script>
